import { AnalyticsService } from './../../../services/analytics.service';
import { Component, Input, OnInit, HostBinding } from '@angular/core';

@Component({
	selector: 'bb-active-filters',
	templateUrl: './bb-active-filters.component.html',
	styleUrls: ['./bb-active-filters.component.scss']
})
export class BbActiveFiltersComponent implements OnInit {
	@Input() filters: {
		name: string;
		values: string[];
	}[];

	constructor(
		public analyticsService: AnalyticsService
	) { }

	ngOnInit(): void {
	}

	clearAll() {
		this.analyticsService.clearAllFilters();
	}

	removeFilter(facetName) {
		this.analyticsService.removeFacetFilter(facetName);
	}
}
